import {authRequest} from './index.js'


export async function get_ticket(ticket_id){
  let data
  await authRequest.get(
    'tickets/' + ticket_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_tickets(params){
  let data
  await authRequest.get(
    '/tickets',
    {
      params:{
        type: params
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    // Check if this is a handled 403 redirect
    if (error.isRedirecting) {
      data = {error: true, isRedirecting: true, statusCode: 403}
    } else {
      data = {error: true, result: error.response?.data, message: error.message, statusCode: error.statusCode}
    }
  })
  return data
}

export async function create_ticket(ticket){
  let data
  await authRequest.post(
    '/tickets',
    { ticket },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_ticket(ticket_id){
  let data
  await authRequest.delete(
    '/tickets/' + ticket_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_ticket(ticket_id, ticket){
  let data
  await authRequest.patch(
    '/tickets/' + ticket_id,
    { ticket },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_ticket_reward(ticket_id, ticket){
  let data
  await authRequest.post(
    `/tickets/${ticket_id}/rewards`,
    { ticket },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}